<template>
  <div class="min-h-screen" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'" :lang="$i18n.locale">
    <Toast />
    <ConfirmDialog />

    <template v-if="$route.meta.guest">
      <router-view></router-view>
    </template>

    <template v-else>
      <AppLayout>
        <router-view></router-view>
      </AppLayout>
    </template>
  </div>
</template>

<script>
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import AppLayout from './components/AppLayout.vue'

export default {
  name: 'App',
  components: {
    AppLayout
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const { locale } = useI18n()

    const isAuthenticated = computed(() => store.getters.isAuthenticated)
    const isAdmin = computed(() => store.getters.isAdmin)

    const items = computed(() => {
      const menuItems = [
        {
          label: 'Dashboard',
          icon: 'pi pi-home',
          to: '/'
        },
        {
          label: 'Employees',
          icon: 'pi pi-users',
          to: '/employees'
        },
        {
          label: 'Users',
          icon: 'pi pi-users',
          to: '/users'
        }
      ]

      return menuItems
    })

    const logout = async () => {
      await store.dispatch('auth/logout')
      router.push('/login')
    }

    // Update document direction based on locale
    const updateDirection = (newLocale) => {
      document.documentElement.dir = newLocale === 'ar' ? 'rtl' : 'ltr'
      document.documentElement.lang = newLocale
    }

    // Set initial direction
    updateDirection(locale.value)

    // Watch for locale changes
    watch(locale, (newLocale) => {
      updateDirection(newLocale)
    })

    return {
      items,
      isAuthenticated,
      logout
    }
  }
}
</script>

<style>
@import 'primevue/resources/themes/lara-light-green/theme.css';
@import 'primevue/resources/primevue.min.css';
@import 'primeicons/primeicons.css';
@import 'primeflex/primeflex.css';

html {
  font-size: 14px;
}

body {
  margin: 0;
  padding: 0;
  min-height: 100vh;
  background-color: var(--surface-ground);
  font-family: var(--font-family);
  color: var(--text-color);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.p-component {
  font-family: var(--font-family);
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background-color: var(--surface-ground);
}

::-webkit-scrollbar-thumb {
  background-color: var(--primary-color);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background-color: var(--primary-600);
}

.card {
  background: var(--surface-card);
  border-radius: var(--border-radius);
  padding: 2rem;
  margin-bottom: 1rem;
  box-shadow: var(--card-shadow);
}

.p-datatable .p-datatable-header {
  background: transparent;
  border: none;
  padding: 0 0 1rem 0;
}

.p-button.p-button-icon-only.p-button-rounded {
  width: 2.5rem;
  height: 2.5rem;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}
</style>
